import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Organization from './Organization'
import { withTheme } from 'styled-components'

class Organizations extends Component {
  render () {
    return (
      <ul className={`organization-list organization-list-${this.props.theme.style}`}>
        {this.getOrganizationList()}
      </ul>
    )
  }

  getOrganizationList () {
    const { dispatch, organizations, user, disabled } = this.props
    return organizations.map(function (organization, index) {
      return (
        <Organization
          key={index}
          dispatch={dispatch}
          organization={organization}
          user={user}
          disabled={disabled}
        />
      )
    })
  }
}

Organizations.propTypes = {
  dispatch: PropTypes.func,
  organizations: PropTypes.array,
  user: PropTypes.object
}

export default withTheme(Organizations)
